import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-gardiennage-industriel-service',
  imports: [RouterLink],
  templateUrl: './gardiennage-industriel-service.html',
  styleUrl: './gardiennage-industriel-service.scss',
})
export class GardiennageIndustrielService {

}
